import { RESIGNATION_STATUS } from "./resignationFormat";

const ResignationStatusBadge = ({ status }) => {
  const meta = RESIGNATION_STATUS[status] || { label: status || "-", tone: "neutral" };
  return <span className={`resignation-badge is-${meta.tone}`}>{meta.label}</span>;
};

export default ResignationStatusBadge;
